import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";

/**
 * Zero-inits every key in `keys`, then increments whichever one `keyFn` maps each account to.
 * Shared by manualTypeCounts/syncedOriginCounts (manage-accounts.component.ts) so a future change
 * to the null-guard or the "missing key vs. a real zero" semantics can't be applied to one and
 * missed in the other, silently reintroducing a loading-flash bug for just one filter section.
 *
 * `accounts` nullish (not yet loaded) returns an empty record rather than zero-initializing every
 * key, so callers can tell "not yet known" apart from "confirmed zero accounts of this kind".
 */
export function countByKey<T extends string>(
  accounts: AccountView[] | null | undefined,
  keys: readonly T[],
  keyFn: (account: AccountView) => T | undefined,
): Partial<Record<T, number>> {
  if (!accounts) {
    return {};
  }
  const counts = {} as Record<T, number>;
  for (const key of keys) {
    counts[key] = 0;
  }
  for (const account of accounts) {
    const key = keyFn(account);
    if (key !== undefined && Object.prototype.hasOwnProperty.call(counts, key)) {
      counts[key]++;
    }
  }
  return counts;
}
